var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9495 2.36376C11.3401 1.97323 11.3401 1.34007 10.9495 0.949546C10.559 0.559021 9.92586 0.559021 9.53533 0.949546L6.00018 4.4847L2.46485 0.949365C2.07432 0.558842 1.44116 0.558841 1.05063 0.949365C0.66011 1.33989 0.660111 1.97305 1.05063 2.36358L4.58597 5.89891L1.05076 9.43412C0.660232 9.82465 0.660232 10.4578 1.05076 10.8483C1.44128 11.2389 2.07445 11.2389 2.46497 10.8483L6.00018 7.31312L9.53521 10.8482C9.92573 11.2387 10.5589 11.2387 10.9494 10.8482C11.3399 10.4576 11.3399 9.82447 10.9494 9.43394L7.41439 5.89891L10.9495 2.36376Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMark);
export default __webpack_public_path__ + "static/media/XMark.cfc988b7fa3312c0bea4823fb65bf04c.svg";
export { ForwardRef as ReactComponent };